export const I18N_ENTITY_SUFFIX_MAPPING = {
  'fr_FR': '',
  'en_US': 'En'
};



// WEBPACK FOOTER //
// ./src/utils/constant.js